import React, { useState, useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import TextInput from '../../../global/components/forms/TextInput.jsx'
import PasswordInput from '../../../global/components/forms/PasswordInput.jsx'

import brandingName from '../../../global/enum/brandingName.jsx'
import apiUtils from '../../../global/utils/api.js'

import UserTermsServicesModal from './UserTermsServicesModal.jsx'

const UserAccountSetupForm = ({ emailToken }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const [values, setValues] = useState({
    name: '',
    firstName: '',
    lastName: '',
    phone: '',
    password: '',
    passwordVerify: '',
  })

  const [loading, setLoading] = useState(false)
  const [showTc, setShowTc] = useState(false)
  const [error, setError] = useState(null)

  const handleFormChange = useCallback(
    e => {
      setValues(existing => ({
        ...existing,
        [e.target.name]: e.target.value,
      }))
    },
    [setValues],
  )

  const onSignup = useCallback(async () => {
    setLoading(true)

    const captchaToken = await executeRecaptcha()

    const result = await apiUtils.callAPI(
      '/api/users/finish-account-creation',
      'POST',
      {
        emailToken: emailToken,
        verifier: localStorage.getItem('signup-verifier'),
        ...values,
        token: captchaToken,
      },
    )

    setLoading(false)

    if (!result.success) {
      setError(result.message)
      return
    }

    window.location = '/user/forward'
  }, [values, setLoading, setError, executeRecaptcha])

  const onSubmit = useCallback(
    e => {
      e.preventDefault()
      setError(null)

      if (values.password != values.passwordVerify) {
        setError('Passwords must match!')
        return
      }

      if (values.password.length < 8) {
        setError('Password must have a minimum length of 8 characters!')
        return
      }

      if (!executeRecaptcha) {
        setError('Can not validate captcha!')
        return
      }

      setShowTc(true)
    },
    [values, setError, executeRecaptcha, setShowTc],
  )

  const onTcClose = useCallback(() => {
    setShowTc(false)
  }, [setShowTc])

  const onTcAccept = useCallback(() => {
    setShowTc(false)
    onSignup()
  }, [setShowTc, onSignup])

  return (
    <div
      className="form-container -skinny"
      style={{ marginTop: '64px' }}
    >
      <form
        className="user-form"
        onSubmit={onSubmit}
      >
        <div style={{ maxWidth: '66%', margin: 'auto' }}>
          <img src={brandingName.image.logoBlack} />
        </div>
        <h2>Sign Up</h2>
        <hr />
        <TextInput
          change={handleFormChange}
          label="Company name"
          name="name"
          placeholder="Doe & Doe Ltd."
          required={true}
          value={values.name}
          minLength="3"
          maxLength="150"
        />
        <TextInput
          change={handleFormChange}
          label="First Name"
          name="firstName"
          placeholder="John"
          required={true}
          value={values.firstName}
          maxLength="150"
        />
        <TextInput
          change={handleFormChange}
          label="Last Name"
          name="lastName"
          placeholder="Doe"
          required={true}
          value={values.lastName}
          maxLength="150"
        />
        <TextInput
          change={handleFormChange}
          label="Phone Number"
          name="phone"
          placeholder="123456789"
          required={true}
          value={values.phone}
          maxLength="150"
        />
        <PasswordInput
          change={handleFormChange}
          label="Password"
          name="password"
          placeholder="Minimum 8 characters"
          value={values.password}
          required={true}
          password={true}
        />
        <PasswordInput
          change={handleFormChange}
          label="Verify password"
          name="passwordVerify"
          placeholder="Minimum 8 characters"
          value={values.passwordVerify}
          required={true}
          password={true}
        />
        {error ? (
          <p style={{ color: '#FF2C2C', textAlign: 'center' }}>{error}</p>
        ) : null}
        <div className="input-group">
          <button
            className="yt-btn info block"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Signing up...' : 'Sign up'}
          </button>
        </div>
      </form>
      <UserTermsServicesModal
        close={onTcClose}
        isOpen={showTc}
        acceptTermsService={onTcAccept}
      />
    </div>
  )
}

export default UserAccountSetupForm
